import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { SiteConfigProvider, useSiteConfigContext } from './hooks/useSiteConfig';
import { I18nProvider } from './i18n/I18nProvider';
import { TrackingProvider } from './contexts/TrackingContext';
import { Router } from './Router';
import { CareerErrorBoundary } from './components/ErrorBoundary';
import { CareerFatalError } from './components/FatalError';
import { MarketingPopup } from './components/MarketingPopup';
import { CookieConsent } from './components/CookieConsent';
import { initCareerHooks, emit } from './lifecycle/careerHooks';
function AppInner() {
    const { config, loading, error, refresh } = useSiteConfigContext();
    useEffect(() => {
        if (config)
            emit('mount');
    }, [config]);
    if (error) {
        // A nyers hiba (API státusz/URL) csak a konzolba megy, a látogató
        // generikus szöveget kap
        console.error('[career] site-config betöltési hiba:', error);
        return (_jsx(CareerFatalError, { title: "Hiba t\u00F6rt\u00E9nt", message: "Az oldal bet\u00F6lt\u00E9se nem siker\u00FClt. K\u00E9rj\u00FCk, pr\u00F3b\u00E1ld \u00FAjra.", onRetry: refresh }));
    }
    if (loading || !config) {
        // [F-KARRIER5B] a boot-fázis betöltője az SSR-preloaddal AZONOS hátteret
        // és logót mutatja (a window.__CAREER_CONFIG__.site-ból) — enélkül a
        // config-fetch alatt a generikus spinner villanna be más háttérrel
        const bootSite = typeof window !== 'undefined' && window.__CAREER_CONFIG__ ? window.__CAREER_CONFIG__.site : undefined;
        const preloadBg = bootSite && bootSite.preload_bg ? bootSite.preload_bg : '';
        const preloadImg = bootSite && bootSite.preload_image ? bootSite.preload_image : '';
        return (_jsx("div", { className: "career-preload", style: preloadBg ? { background: preloadBg } : undefined, children: preloadImg ? (_jsx("img", { src: preloadImg, alt: "", className: "career-preload-image" })) : (_jsxs(_Fragment, { children: [_jsx("div", { className: "spinner" }), _jsx("p", { children: "Bet\u00F6lt\u00E9s..." })] })) }));
    }
    return (_jsx(I18nProvider, { value: {
            system: config.translations.system,
            client: config.translations.client,
            content: config.translations.content || {},
            contactTexts: config.translations.contact_texts || {},
            current: config.language.current,
        }, children: _jsx(TrackingProvider, { children: _jsxs("div", { className: "career-app", children: [_jsx(Router, {}), config.popup && config.popup.visible && (_jsx(MarketingPopup, { popup: config.popup })), config.tracking && config.tracking.cookie_banner
                        && config.tracking.cookie_banner.enabled && (_jsx(CookieConsent, { config: config }))] }) }) }));
}
export function App() {
    useEffect(() => {
        initCareerHooks();
    }, []);
    return (_jsx(CareerErrorBoundary, { children: _jsx(SiteConfigProvider, { children: _jsx(AppInner, {}) }) }));
}
